import React, { useEffect, useState } from 'react';
import BNMark from './BNMark';

/* Waiting on something: the B/N mark's outer ring turns. Shown only after a
   short delay so quick loads don't flicker; still for "reduce motion". */
export default function Loader({ label = 'Loading…', size = 44, inline = false, delay = 300 }) {
  const [show, setShow] = useState(delay === 0);
  useEffect(() => {
    if (delay === 0) return undefined;
    const t = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(t);
  }, [delay]);
  return (
    <div className={inline ? 'bn-loader inline' : 'bn-loader'} role="status" aria-live="polite">
      {show && <BNMark size={inline ? 18 : size} spinning hub />}
      <span className={inline ? 'bn-loader-label' : 'sr-only'}>{label}</span>
    </div>
  );
}
